var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-jumbotron',{staticClass:"m-5",attrs:{"header":"Tiermittel-Datenbank"}},[_c('p',[_vm._v(_vm._s(_vm.$t('maintenanceText')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }